__turbopack_context__.v({
  "anchor": "_AfnwG_anchor",
});
